module.exports = __webpack_public_path__ + "img/logo.f5cc267b.png";